import { useEffect } from 'react';

import { EmbeddedApp } from './components/EmbeddedApp.js';
import { Login } from './components/Login.js';
import { ProjectTabStrip } from './components/ProjectTabs.js';
import { Shell } from './components/Shell.js';
import { TitleBar } from './components/TitleBar.js';
import { isDesktopShell } from './lib/desktop.js';
import { isEmbedded } from './lib/embed.js';
import { WEBSITE } from './lib/edition.js';
import { WebsiteApp } from './components/website/WebsiteApp.js';
import { AppBell } from './components/social/AppBell.js';
import { useAuth } from './state/auth.js';
import { useProjectTabs } from './state/project-tabs.js';

export function App() {
  // A project tab's iframe renders just that project's workspace; the Prism
  // website has its own pages around it.
  if (isEmbedded()) return <EmbeddedApp />;
  return WEBSITE ? <WebsiteApp /> : <HostApp />;
}

function HostApp() {
  const status = useAuth((s) => s.status);
  const bootstrap = useAuth((s) => s.bootstrap);
  const hasTabs = useProjectTabs((s) => s.tabs.length > 0);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (status === 'loading') {
    return (
      <div className="boot">
        <div className="spinner" aria-label="Loading" />
      </div>
    );
  }

  const authenticated = status === 'authenticated';
  const desktop = isDesktopShell();

  // The title bar and the shell share one definite-height column, so the
  // resizable panes below still get a height to divide up. Project tabs live
  // in the title bar on desktop and in a slim strip of their own on the web.
  return (
    <div className="app-root">
      <TitleBar tabs={authenticated ? <ProjectTabStrip variant="titlebar" /> : null} extra={authenticated ? <AppBell /> : null} />
      {authenticated && !desktop && hasTabs && (
        <div className="ptabs-bar">
          <ProjectTabStrip variant="bar" />
        </div>
      )}
      {authenticated ? <Shell /> : <Login />}
    </div>
  );
}
